import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react"; // hamburger icons

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/add", label: "Add" },
  { to: "/calendar", label: "Calendar" },
  { to: "/infographic", label: "Infographic" },
  { to: "/more", label: "More" }, // เพิ่ม More ที่นี่
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 w-full z-30 bg-white border-b shadow-sm">
      <div className="max-w-4xl mx-auto flex items-center justify-between px-4 py-2">
        {/* Logo (หรือใช้ svg แทน) */}
        <Link to="/" className="font-extrabold text-xl text-indigo-600 tracking-tight">Spendora</Link>
        
        {/* Desktop menu */}
        <div className="hidden md:flex gap-4 items-center">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-medium ${location.pathname === link.to ? "text-indigo-600" : "text-gray-700"} hover:text-indigo-400 transition`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        {/* Hamburger icon for mobile */}
        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu (slide-down) */}
      {open && (
        <div className="md:hidden bg-white border-t px-4 pb-3 animate-slide-down absolute w-full left-0 shadow z-40">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-3 text-lg font-medium ${location.pathname === link.to ? "text-indigo-600" : "text-gray-800"}`}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}